import React from 'react';
import debounce from 'debounce';
import { Card, Input, Row } from 'antd';
import { searchProducts } from './actions';

import { SUPPLIER_URL } from '../../index';

class ProductList extends React.PureComponent{

	render(){

		const { width } = this.state;

		return (
			<Card
				title={(
					<Input 
						placeholder="Search Product Name" 
						style={{width}} 
						onChange={this.handleOnChange}
						onFocus={this.handleOnFocus} 
						onBlur={this.handleOnBlur}/>
				)}>

				{this.renderProductList()}
				
			</Card>
		)

	}

	renderProductList = () => {

		const { loading, products } = this.state;

		if(loading){
			return <Row>Loading...</Row>
		}

		if(products.length > 0){
			return products.map(
				product => (
					<Row>
						<a target={product._id} href={`${SUPPLIER_URL}/products/${product._id}`}>{product.title}</a>
					</Row>
				)
			)
		} else {
			return <Row>Please search a product title</Row>
		}
	}

	state = {
		width: 200,
		loading: false,
		products: []
	}

	constructor(props){
		super(props);
		this.searchProducts = debounce(this.searchProducts, 500);
	}

	handleOnBlur = () => {
		this.setState({width: 200})
	}

	handleOnChange = (e) => {

		const { value } = e.target;

		if(!value){
			return this.setState({
				products: [],
				loading: false
			})
		}

		this.setState({
			loading: true
		})

		this.searchProducts(value);

	}

	handleOnFocus = () => {
		this.setState({width: 400})
	}

	searchProducts = (value) => {
		searchProducts(value)
			.then( res => {
				this.setState({
					products: res.data.products,
					loading: false
				})
			})
	}

}

export default ProductList;


// WEBPACK FOOTER //
// ./src/components/product/list.js